// src/pages/EleccionesVotacion.jsx

import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import { API } from "../components/config";

import "../style/EleccionesVotacion.css";

export default function EleccionesVotacion() {

  /* =====================================================
     TOKEN
  ===================================================== */

  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`
  };

  /* =====================================================
     USER / ROLE
  ===================================================== */

  const user =
    JSON.parse(localStorage.getItem("user")) || {};

  const role = (
    user?.role || ""
  )
    .toString()
    .trim()
    .toLowerCase();

  /* =====================================================
     STATES
  ===================================================== */

  const [elecciones, setElecciones] = useState([]);

  const [candidatos, setCandidatos] = useState([]);

  const [eleccionActiva, setEleccionActiva] = useState(null);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const [mensaje, setMensaje] = useState("");

  const [yaVoto, setYaVoto] = useState(false);

  /* =====================================================
     LISTAR ELECCIONES
  ===================================================== */

  const fetchElecciones = async () => {

    try {

      setError("");

      const res = await axios.get(
        `${API}/elecciones`,
        { headers }
      );

      console.log("ROLE:", role);
      console.log("ELECCIONES:", res.data);

      /* =================================================
         FILTRAR ELECCIONES SEGÚN ROL
      ================================================= */

      const activas = Array.isArray(res.data)
        ? res.data.filter((el) => {

            /* ===============================
               SOLO ACTIVAS
            =============================== */

            if (el.estado !== "ACTIVA") {
              return false;
            }

            /* ===============================
               SOLO ESTUDIANTES
            =============================== */

            if (
              el.dirigida_a === "ESTUDIANTES" &&
              role !== "estudiante"
            ) {
              return false;
            }

            /* ===============================
               SOLO PROFESORES
            =============================== */

            if (
              el.dirigida_a === "DOCENTES" &&
              role !== "profesor"
            ) {
              return false;
            }

            return true;

          })
        : [];

      setElecciones(activas);

    } catch (err) {

      console.log(err);

      setError("Error cargando elecciones");

    }

  };

  useEffect(() => {
    fetchElecciones();
  }, []);

  /* =====================================================
     VER CANDIDATOS
  ===================================================== */

  const verCandidatos = async (eleccion) => {

    try {

      setLoading(true);

      setMensaje("");

      setError("");

      setYaVoto(false);

      setEleccionActiva(eleccion);

      /* =================================================
         CARGAR CANDIDATOS
      ================================================= */

      const candidatosRes = await axios.get(
        `${API}/electionCandidates/${eleccion.id}/candidates`,
        { headers }
      );

      setCandidatos(
        candidatosRes.data.data || []
      );

      /* =================================================
         VALIDAR SI YA VOTÓ
      ================================================= */

      try {

        const votoRes = await axios.get(
          `${API}/elecciones/${eleccion.id}/mi-voto`,
          { headers }
        );

        setYaVoto(
          votoRes.data?.yaVoto || false
        );

      } catch (err) {

        console.log(err);

      }

    } catch (err) {

      console.log(err);

      setError("Error cargando candidatos");

    } finally {

      setLoading(false);

    }

  };

  /* =====================================================
     VOTAR
  ===================================================== */

  const votar = async (candidate_id) => {

    try {

      const confirmar = window.confirm(
        "¿Seguro que deseas votar por este candidato?"
      );

      if (!confirmar) return;

      setLoading(true);

      setMensaje("");

      setError("");

      const res = await axios.post(
        `${API}/elecciones/${eleccionActiva.id}/votar`,
        {
          candidate_id
        },
        {
          headers
        }
      );

      setMensaje(
        res.data.message ||
        "Voto registrado correctamente"
      );

      setYaVoto(true);

    } catch (err) {

      console.log(err);

      setError(
        err?.response?.data?.message ||
        "Error registrando voto"
      );

    } finally {

      setLoading(false);

    }

  };

  /* =====================================================
     UI
  ===================================================== */

  return (

    <div className="elecciones-votacion-container">

      <h2>
        🗳️ Elecciones Institucionales
      </h2>

      {/* =================================================
         ROLE DEBUG
      ================================================= */}

      <p>
        <b>Rol detectado:</b> {role}
      </p>

      {/* =================================================
         ERROR
      ================================================= */}

      {error && (
        <p className="error">
          {error}
        </p>
      )}

      {/* =================================================
         SUCCESS
      ================================================= */}

      {mensaje && (
        <p className="success">
          {mensaje}
        </p>
      )}

      {/* =================================================
         LISTA ELECCIONES
      ================================================= */}

      {!eleccionActiva && (

        <div className="grid">

          {elecciones.length === 0 ? (

            <p>
              No hay elecciones activas para tu rol
            </p>

          ) : (

            elecciones.map((el) => (

              <div
                key={el.id}
                className="card"
              >

                <h3>
                  {el.nombre}
                </h3>

                <p>
                  {el.descripcion}
                </p>

                <p>
                  <b>
                    Dirigida a:
                  </b>{" "}
                  {el.dirigida_a}
                </p>

                <p>
                  <b>
                    Estado:
                  </b>{" "}
                  {el.estado}
                </p>

                <button
                  onClick={() =>
                    verCandidatos(el)
                  }
                >
                  👁 Ver candidatos
                </button>

              </div>

            ))

          )}

        </div>

      )}

      {/* =================================================
         CANDIDATOS
      ================================================= */}

      {eleccionActiva && (

        <div>

          <button
            className="btn-back"
            onClick={() => {

              setEleccionActiva(null);

              setCandidatos([]);

              setYaVoto(false);

              setMensaje("");

              setError("");

            }}
          >
            ← Volver
          </button>

          <h3>
            🧑‍💼 Candidatos -{" "}
            {eleccionActiva.nombre}
          </h3>

          <div className="grid">

            {candidatos.length === 0 ? (

              <p>
                No hay candidatos registrados
              </p>

            ) : (

              candidatos.map((candidato) => (

                <div
                  key={candidato.id}
                  className="card"
                >

                  {/* FOTO */}

                  {candidato.foto ? (

                   <img
  src={candidato.foto}
  alt={candidato.nombre}
  className="candidate-photo"
  style={{
    width: "100%",
    height: "220px",
    objectFit: "cover",
    borderRadius: "12px"
  }}
/>

                  ) : (

                    <div className="photo-placeholder">
                      Sin foto
                    </div>

                  )}

                  {/* INFO */}

                  <h3>
                    {candidato.nombre}
                  </h3>

                  <p>
                    <b>
                      Número:
                    </b>{" "}
                    {candidato.numero}
                  </p>

                  <p>
                    {candidato.propuesta}
                  </p>

                  {/* BOTÓN */}

                  {!yaVoto ? (

                    <button
                      disabled={loading}
                      onClick={() =>
                        votar(candidato.id)
                      }
                    >
                      🗳️ Votar
                    </button>

                  ) : (

                    <button disabled>
                      ✅ Ya votaste
                    </button>

                  )}

                </div>

              ))

            )}

          </div>

        </div>

      )}

    </div>

  );

}